import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f72a896"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "surface-100 border-round-lg p-4"
}
const _hoisted_2 = { class: "text-2xl font-semibold border-none my-2" }
const _hoisted_3 = { class: "flex flex-wrap p-2 gap-4" }
const _hoisted_4 = { class: "font-semibold flex align-items-center gap-2 border-none mb-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_down" }, null, -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "flex flex-column pl-2 alert orange-alert" }
const _hoisted_8 = { class: "alert-header" }
const _hoisted_9 = { class: "alert-title" }
const _hoisted_10 = { class: "alert-description" }
const _hoisted_11 = { class: "alert-dates" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.alerts.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("weather.alerts.title")), 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (alert) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex font-semibold gap-2 align-items-center",
              key: alert.id
            }, [
              (alert.icon)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: _normalizeClass('weatherIcon ' + alert.icon),
                    style: _normalizeStyle({
            backgroundColor: _ctx.getSeverityColor(alert.severity),
          })
                  }, null, 6))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("weather.alerts.weather_event." + alert.sub_category)), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleAllAlertDetails && _ctx.toggleAllAlertDetails(...args))),
            class: "cursor-pointer"
          }, [
            _createElementVNode("h3", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.$t("weather.alerts.info")) + " ", 1),
              _hoisted_5
            ])
          ]),
          (_ctx.showAllDetails)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (alert) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: alert.id,
                      class: "alert"
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        (alert.icon)
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 0,
                              class: _normalizeClass('weatherIcon ' + alert.icon),
                              style: _normalizeStyle({
                  backgroundColor: _ctx.getSeverityColor(alert.severity),
                })
                            }, null, 6))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.getAlertTypeText(alert.sub_category)), 1)
                      ]),
                      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.getAlertDescription(alert)), 1),
                      _createElementVNode("p", _hoisted_11, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("weather.alerts.valid_from")) + ":", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$moment(alert.valid_from).format("DD.MM.YYYY, HH:mm")), 1),
                        _hoisted_12,
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("weather.alerts.valid_to")) + ":", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$moment(alert.valid_to).format("DD.MM.YYYY, HH:mm")), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}